import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { getNumberValidFilter } from '@anytag/shared-utils';
import { usePostsFilterOptions } from '@anytag/shared-organisms';
import { GenderField, KeywordField, PostCountryField, PostSocialMediaField, InfluencerTabField } from '../../shared';
import { BasicFilterDefaultProps } from '../../schemaTypes';
import { InfluencerPostsFilterFormKeys, InfluencerPostsFilterFormValues } from '../schemaTypes';
import { AdvancedFilter } from './AdvancedFilter';

export const BasicFilter = ({ onSubmit, isEngagementPage }: BasicFilterDefaultProps) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<InfluencerPostsFilterFormValues>();
  const { isCNCountrySupported } = usePostsFilterOptions();

  const values = watch();
  const numOfValidFilter = getNumberValidFilter<InfluencerPostsFilterFormKeys>(values, [
    'tab',
    'keyword',
    'genders',
    'countryId',
    'includeIds',
    'socialMedia'
  ]);

  return (
    <Form.Fields>
      <InfluencerTabField isEngagementPage={isEngagementPage} onSubmit={onSubmit} />
      <KeywordField onSubmit={onSubmit} placeholder={t<string>('Search.InfluencerPostFilter')} />
      <PostSocialMediaField onSubmit={onSubmit} className="max-w-37.5" />
      <GenderField onSubmit={onSubmit} className="max-w-31" />
      <PostCountryField onSubmit={onSubmit} disabled={isCNCountrySupported} />
      <AdvancedFilter count={numOfValidFilter} onSubmit={onSubmit} isEngagementPage={isEngagementPage} />
    </Form.Fields>
  );
};
